import React, {useEffect, useState, useCallback} from 'react';
import axios from 'axios';
import urlList from '../../reducers/propertiesReducer';
import getAxiosConfig from '../../utils/axiosConfig';
import SegmentationSearcher from './SegmentationSearcher';
import NoResults from './NoResults';

const SegmentationDetailsModal = ({isOpen, onClose, segmentation, segmentationType}) => {
    const [segmentationDetails, setSegmentationDetails] = useState(null);
    const [userExternalIds, setUserExternalIds] = useState([]);
    const [searchUserId, setSearchUserId] = useState('');
    const [filteredUserIds, setFilteredUserIds] = useState([]);
    const [segmentationId, setSegmentationId] = useState('');
    const [segmentId, setSegmentId] = useState('');
    const [type, setType] = useState('');
    const [currentSegmentIndex, setCurrentSegmentIndex] = useState(null);
    const [showUserIds, setShowUserIds] = useState(false);

    const fetchSegmentationDetails = async (segmentationId) => {
        try {
            const response = await axios.get(
                `${urlList().segmentationUrl}/getSegmentationDefinition/${segmentationId}_${segmentationType}`,
                getAxiosConfig()
            );
            const [firstSegmentationDetail] = response.data;
            setSegmentationDetails(response.data);
            setSegmentationId(firstSegmentationDetail.segmentationId);
            setType(firstSegmentationDetail.type);
            setSegmentId(firstSegmentationDetail.segmentId);
        } catch (error) {
            console.error('Error fetching segmentation details:', error);
        }
    };

    const fetchUserExternalIds = (segmentId) => {
        axios
            .get(
                `${urlList().segmentationUrl}/getUsersInSegment/${segmentId}`,
                getAxiosConfig()
            )
            .then((response) => {
                setUserExternalIds(response.data);
            })
            .catch((error) => {
                console.error('Error fetching user external ids:', error);
            });
    };

    const handleShowUserIds = (segmentId, index) => {
        setCurrentSegmentIndex(index);
        setShowUserIds(true);
        fetchUserExternalIds(segmentId);
    };

    const handleSearch = useCallback(() => {
        if (searchUserId.trim() !== '') {
            const filteredIds = userExternalIds.filter((id) =>
                id.includes(searchUserId)
            );
            setFilteredUserIds(filteredIds);
        } else {
            setFilteredUserIds(userExternalIds.slice(0, 10));
        }
    }, [searchUserId, userExternalIds]);

    useEffect(() => {
        handleSearch();
    }, [searchUserId, userExternalIds, handleSearch]);

    useEffect(() => {
        if (isOpen && segmentation) {
            setCurrentSegmentIndex(null);
            fetchSegmentationDetails(segmentation.segmentationId);
            fetchUserExternalIds(segmentation.segmentId);
        }
    }, [isOpen, segmentation]);

    if (!isOpen) return null;

    return (
        <div className="segmentation-details-modal">
            <div className="edit-modal-content">
        <span className="creation-segmentation-close" onClick={onClose}>
          &times;
        </span>
                <h2>Segmentation Group Details</h2>
                <SegmentationSearcher segmentationName={segmentation.segmentationName}/>
                {segmentationDetails ? (
                    <div className="segmentation-details-context-group">
                        {segmentationDetails.map((segmentationDetail, index) => (
                            <div key={index} className="segmentation-details-context">
                                <p>
                                    <strong>Name: </strong> {segmentationDetail.segmentName}
                                </p>
                                <p>
                                    <strong>Filter: </strong>{' '}
                                    {segmentationDetail.spelfilterString}
                                </p>
                                <button
                                    onClick={() =>
                                        handleShowUserIds(
                                            segmentationDetail.segmentId,
                                            index
                                        )
                                    }
                                >
                                    Show User Ids
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <NoResults/>
                )}
                {showUserIds && (
                    <>
                        <div className="segmentation-ids-details">
                            <ul>
                                <h2>User ids:</h2>
                                {filteredUserIds.map((userExternalId, index) => (
                                    <li key={index}>
                                        <div>{userExternalId}</div>
                                    </li>
                                ))}
                            </ul>
                            {filteredUserIds.length === 0 && <NoResults/>}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default SegmentationDetailsModal;




